export default __webpack_public_path__ + "static/media/afct 1.0a45f58d.webp";